var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';








const Modal = ({ children, size, id }) => {
  const sizes = {
    sm: 'max-w-sm',
    md: 'max-w-md min-w-[24rem]',
    lg: 'max-w-lg min-w-[28rem]',
    xl: 'max-w-xl min-w-[32rem]',
    xxl: 'max-w-2xl min-w-[36rem]',
    xxxl: 'max-w-3xl min-w-[40rem]'
  };

  return (/*#__PURE__*/
    _jsx("div", {
      "aria-hidden": "false",
      className: "fixed inset-0 top-0 left-0 z-50 flex items-center justify-center overflow-x-hidden bg-gray-900 bg-opacity-50",
      "data-testid": "modal",
      role: "dialog",
      "aria-label": "Modal",
      id: id }, void 0, /*#__PURE__*/

    _jsx("div", { className: `max-h-screen ${sizes[size]}` }, void 0, /*#__PURE__*/
    _jsx("div", { className: "bg-white rounded-lg shadow" }, void 0, children)
    )
    ));

};






Modal.Header = ({ children, className }) => /*#__PURE__*/
_jsx("div", {
  className: `${className} flex items-start justify-between rounded-t ${
  children ? 'p-5 border-b' : 'p-2'}` }, void 0,


children
);


Modal.Body = ({ children, className }) => /*#__PURE__*/
_jsx("div", {
  className: `overflow-y-auto p-6 h-full md:max-h-[70vh] ${className}`,
  "data-testid": "modal-body" }, void 0,

children
);


Modal.Footer = ({ children }) => /*#__PURE__*/
_jsx("div", { className: "flex justify-center p-6 space-x-2 border-t border-gray-200 rounded-b" }, void 0,
children
);


Modal.CloseButton = ({
  className,
  onClick,
  disabled
}) => /*#__PURE__*/
_jsx("button", {
  onClick: onClick,
  "aria-label": "Close modal",
  className: `${className} ml-auto inline-flex items-center rounded-lg bg-transparent 
    p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 `,
  type: "button",
  disabled: disabled }, void 0, /*#__PURE__*/

_jsx(XMarkIcon, { className: "w-4" })
);



export { Modal };